import { Component, OnInit } from '@angular/core';
import { FooterInfoService } from '../../../../../../projects/tekkeys-common/src/lib/DAO/footer/footer-info.service';
import { footerInfoDto } from '../../../../../../projects/tekkeys-common/src/lib/DTO/footer-info.dto';
import { ThemeService } from 'shared/services/parameter/theme.service';
import { ParameterModel } from 'shared/services/parameter/parameter.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer-info',
  templateUrl: './footer-info.component.html',
  styleUrls: ['./footer-info.component.scss'],
})
export class FooterInfoComponent implements OnInit {
  logoUrl$: Observable<string>;
  parameter$: Observable<ParameterModel>;
  contactInformation: footerInfoDto[];

  constructor(
    private serviceFooter: FooterInfoService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.logoUrl$ = this.themeService.logo$;
    this.parameter$ = this.themeService.parameter$;
  }
}
